module.exports = __webpack_public_path__ + "img/light-bulb.b0d40a4a.svg";